import { apiClient } from "../../client";
import { PaginatedResponse } from "../role.repository";

export interface SKUDepartment {
    id: number;
    bu: string;
    bu_id: number;
    en_name: string;
    ar_name: string;
    status: number;
    ref_code?: string
    created_by: number | null;
    updated_by: number | null;
    created_at: Date;
    updated_at: Date;
    skubu?: { id: number; en_name: string }
}

export interface CreateSKUDepartmentRequest {
    bu: number;
    en_name: string;
    ar_name?: string;
    status?: number;
    ref_code?: string;
}
export interface UpdateSKUDepartmentRequest {
    bu?: number;
    en_name?: string;
    ar_name?: string;
    status?: number;
    ref_code?: string;


}

class DepartmentRepository {

    async getAll(page: number = 1, limit: number = 25, filters?: any): Promise<PaginatedResponse<SKUDepartment>> {

        const params = new URLSearchParams({
            page: page.toString(),
            limit: limit.toString()
        });

        if (filters) {
            if (filters.search) params.append('search', filters.search);
            if (filters.status) params.append('status', filters.status)
        }

        return apiClient.get<PaginatedResponse<SKUDepartment>>(`/department?${params.toString()}`)

    }

    async create(data: CreateSKUDepartmentRequest): Promise<SKUDepartment> {
        return apiClient.post<SKUDepartment>('/department/sku-department', data)
    }

    async update(id: number, data: UpdateSKUDepartmentRequest): Promise<SKUDepartment> {
        return apiClient.put<SKUDepartment>(`/department/sku-department/${id}`, data)
    }

    async delete(id: number): Promise<{ message: string }> {
        return apiClient.delete<{ message: string }>(`/department/sku-department/${id}`)
    }
    async exportToExcel(filters?: any): Promise<Blob> {
        const params = new URLSearchParams()
        if (filters?.search) params.append('search', filters.search)
        if (filters?.status) params.append('status', filters.status)

        if (filters?.principal_id) params.append('principal_id', filters.principal_id.toString())

        const baseUrl = `/department/sku-department/export/excel`;
        const queryString = params.toString();
        const url = queryString ? `${baseUrl}?${queryString}` : baseUrl;

        return apiClient.getBlob(url, true, { showSuccessToast: true, successMessage: 'Exported Successfully' })
    }


}

export const departmentRepository = new DepartmentRepository();